import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import DOMPurify from 'dompurify';
import settingsService from '../../services/settings.service';
import { getAnalyticsConfig } from '../../lib/analytics';
import './publicRichText.css';

export default function PrivacyPolicy() {
  const [settings, setSettings] = useState({});
  const [analytics, setAnalytics] = useState({});
  useEffect(() => {
    void settingsService
      .getPublicSettings()
      .then(setSettings)
      .catch(() => {});
    void getAnalyticsConfig().then(setAnalytics);
  }, []);
  const html = (settings.privacyPolicyHtml || '').trim();
  return (
    <div className='min-h-screen bg-white text-ink'>
      <Helmet>
        <title>Política de Privacidad</title>
      </Helmet>
      <main className='mx-auto max-w-3xl px-4 py-10 lg:py-14'>
        <h1 className='mb-6 text-3xl font-bold'>Política de Privacidad</h1>
        {html ? (
          <div
            className='public-page-rich-text'
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html, { ADD_ATTR: ['class'] }) }}
          />
        ) : (
          <p>
            {settings.companyName || 'Este sitio'} trata los datos de compradores para gestionar
            reservas, pagos y entrega de tickets. Contacto:{' '}
            {settings.companyEmail?.[0] || 'consultá con el organizador'}.
          </p>
        )}
        {(analytics.ga4MeasurementId || analytics.clarityProjectId) && (
          <section className='mt-8 space-y-3'>
            <h2 className='text-xl font-semibold'>Analítica del sitio</h2>
            {analytics.ga4MeasurementId && (
              <p>Usamos Google Analytics 4 para medir visitas y uso del sitio.</p>
            )}
            {analytics.clarityProjectId && (
              <p>
                Usamos Microsoft Clarity para grabaciones de las páginas públicas de navegación y
                mapas de calor. No grabamos las páginas de datos personales, pago ni administración.
              </p>
            )}
          </section>
        )}
      </main>
    </div>
  );
}
